import { render } from "./IntegratedCountBoxChild.vue?vue&type=template&id=10a64656&scoped=true"
import script from "./IntegratedCountBoxChild.vue?vue&type=script&lang=js"
export * from "./IntegratedCountBoxChild.vue?vue&type=script&lang=js"

import "./IntegratedCountBoxChild.vue?vue&type=style&index=0&id=10a64656&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a64656"]])

export default __exports__